import React, { Component, Fragment } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Responsive } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { ProductionGridFieldEnum as ProductionGridFields } from 'Common/FieldEnum';
import { PRODUCTION_GRID_FORM_NAME } from 'Common/FormEnum';
import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { SiteSelectField } from 'Common/ReduxFormFields';
import { createToast, toastType } from 'Common/ToastHelper';
import { AllOptionEnum } from 'Common/Constants/Enumeration/PropEnums';
import { resetDirty } from 'State/dirtyTracking/actions';

import * as ManageProductionActions from '../state/manageproduction/actions';
import * as ManageProductionSelectors from '../state/manageproduction/selectors';
import { PLANNED_STATUS_OPTIONS } from '../helpers/Constants';

class ProductionRecordTableForm extends Component {
  componentDidMount() {
    const {
      startDate,
      endDate,
      siteId,
      cycleMenuId,
      status,
      getProdRecords,
      getSiteMenus,
    } = this.props;

    if (startDate && endDate && siteId) {
      const siteIds = [siteId];

      const data = {
        [ProductionGridFields.StartDate]: startDate,
        [ProductionGridFields.EndDate]: endDate,
        [ProductionGridFields.SiteIds]: siteIds,
        [ProductionGridFields.CycleMenuId]: cycleMenuId,
        [ProductionGridFields.Status]: status,
      };

      getSiteMenus(siteIds);
      getProdRecords(data);
    }
  }

  onSitesChange = (e, value) => {
    const { getSiteMenus } = this.props;

    // TODO handle site groups
    const siteIds = [value];

    getSiteMenus(siteIds);
  };

  render() {
    const { siteMenusOptions, fetchingSiteMenus } = this.props;

    return (
      <Grid>
        <Responsive
          minWidth={1341}
          as={Grid.Row}
          style={{ marginLeft: 6 }}
          columns="equal"
        >
          <Grid.Column>
            <Field
              name={ProductionGridFields.SiteId}
              label="Select Site"
              component={SiteSelectField}
              allOption={AllOptionEnum.None}
              onChange={this.onSitesChange}
              fetchAllSites={true}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              label="Select Menu"
              name={ProductionGridFields.CycleMenuId}
              options={siteMenusOptions}
              component={SelectField}
              loading={fetchingSiteMenus}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              label="Production Record Status"
              name={ProductionGridFields.Status}
              options={PLANNED_STATUS_OPTIONS}
              component={SelectField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              label="Start Date"
              component={DatePickerField}
              name={ProductionGridFields.StartDate}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              label="End Date"
              component={DatePickerField}
              name={ProductionGridFields.EndDate}
            />
          </Grid.Column>
        </Responsive>
        <Responsive maxWidth={1340} as={Fragment}>
          <Grid.Row style={{ marginLeft: 6 }}>
            <Grid.Column width={5}>
              <Field
                name={ProductionGridFields.SiteId}
                label="Select Site"
                component={SiteSelectField}
                allOption={AllOptionEnum.None}
                onChange={this.onSitesChange}
                fetchAllSites={true}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                label="Select Menu"
                name={ProductionGridFields.CycleMenuId}
                options={siteMenusOptions}
                component={SelectField}
                loading={fetchingSiteMenus}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                label="Production Record Status"
                name={ProductionGridFields.Status}
                options={PLANNED_STATUS_OPTIONS}
                component={SelectField}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginLeft: 6 }}>
            <Grid.Column width={5}>
              <Field
                label="Start Date"
                component={DatePickerField}
                name={ProductionGridFields.StartDate}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                label="End Date"
                component={DatePickerField}
                name={ProductionGridFields.EndDate}
              />
            </Grid.Column>
          </Grid.Row>
        </Responsive>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  fetchingSiteMenus: ManageProductionSelectors.getFetchingMenus(state),
  siteMenusOptions: ManageProductionSelectors.getSiteMenusOptions(state),
  startDate: ManageProductionSelectors.getStartDate(state),
  endDate: ManageProductionSelectors.getEndDate(state),
  siteId: ManageProductionSelectors.getSiteId(state),
  status: ManageProductionSelectors.getStatus(state),
  cycleMenuId: ManageProductionSelectors.getCycleMenuId(state),
});

const mapDispatchToProps = {
  getSiteMenus: ManageProductionActions.getSiteMenus,
  getProdRecords: ManageProductionActions.getProdRecords,
  resetDirty,
};

const fetchProdRecordFields = [
  ProductionGridFields.SiteId,
  ProductionGridFields.CycleMenuId,
  ProductionGridFields.Status,
  ProductionGridFields.StartDate,
  ProductionGridFields.EndDate,
];

const onChange = (values, dispatch, props, previousValues) => {
  const { getProdRecords, resetDirty } = props;

  // Form isn't used for submission, so reset it to avoid having it bring up
  // the dirty prompt
  resetDirty();

  const shouldFetchProdRecords = fetchProdRecordFields.some(
    (field) => values[field] !== previousValues[field]
  );

  if (shouldFetchProdRecords) {
    const requiredFields = [
      ProductionGridFields.SiteId,
      ProductionGridFields.StartDate,
      ProductionGridFields.EndDate,
    ];

    if (requiredFields.every((field) => Boolean(values[field]))) {
      const startDate = values[ProductionGridFields.StartDate];
      const endDate = values[ProductionGridFields.EndDate];
      const data = _.pick(values, fetchProdRecordFields);
      data[ProductionGridFields.SiteIds] = [
        values[ProductionGridFields.SiteId],
      ];

      if (moment(endDate).isBefore(startDate)) {
        createToast(
          toastType.error,
          'Error',
          'Start date must be before the end date.'
        );
        return;
      }

      getProdRecords(data);
    }
  }
};

ProductionRecordTableForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: PRODUCTION_GRID_FORM_NAME,
    destroyOnUnmount: false,
    onChange,
  })(ProductionRecordTableForm)
);

export { ProductionRecordTableForm };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/components/ProductionRecordTableForm.js